export const BANNER_TIMEOUT = 5000;
export const PUBLIC_REGISTER_APPLICATION_URL = `${process.env.REACT_APP_PUBLIC_REGISTER_URL}application/arn/`;
export const TERMS_CONDITIONS_URL = `${process.env.REACT_APP_TERMSCONDITIONS_URL}`;
export const DOCUMENT_STORE_TENANT_ID = `${process.env.REACT_APP_DOCUMENT_STORE_TENANT_ID}`;
